export interface ITableData {
  [key: string]: string | number
}

export interface IColumnOptions {
  header: string;
  isJourneyMapButton?: boolean;
  isIncidentMapButton?: boolean;
  isBookingRefButton?: boolean;
  isPinned?: boolean;
  isSortable?: boolean;
  isFilterable?: boolean;
  isResizable?: boolean;
  hasMenu?: boolean;
  width?: number;
  flex?: number;
}

export interface ITableOptions {
  enableCSVDownload?: boolean;
  height?: number;
  description?: string;
  columns?: {
    [key: keyof ITableData]: IColumnOptions
  }
}

export function isTableOptions(obj: unknown): obj is ITableOptions {
  if (!obj || typeof (obj) !== "object") {
    console.warn(`Table Options validation failed: ${obj} is not a valid object.`)
    return false
  }

  if ("enableCSVDownload" in obj) {
    if (typeof (obj.enableCSVDownload) !== "boolean") {
      console.warn(`Table Options validation failed: enableCSVDownload is not a boolean value, received: ${obj.enableCSVDownload}`)
      return false
    }
  }

  if ("columns" in obj) {
    if (typeof obj.columns !== "object" || !obj.columns) {
      console.warn(`Table Options validation failed: ${obj.columns} is not a valid object.`)
      return false
    }

    const isValid = Object.values(obj.columns).every((o) => isColumnOptions(o))
    if (!isValid) {
      return false
    }
  }

  if ("height" in obj) {
    if (typeof (obj.height) !== "number") {
      console.warn(`Table Options validation failed: ${obj.height} is not a valid number.`)
      return false
    }
  }

  return true
}

function isColumnOptions(obj: unknown): obj is IColumnOptions {
  if (!obj || typeof (obj) !== "object") {
    console.warn(`Column Options validation failed: ${obj} is not a valid object.`)
    return false
  }

  if (!("header" in obj) || typeof obj.header !== "string") {
    console.warn(`Column Options validation failed: missing required "header" property.`)
    return false
  }

  if ("isJourneyMapButton" in obj) {
    if (typeof (obj.isJourneyMapButton) !== "boolean") {
      console.warn(`Column Options validation failed: isJourneyMapButton is not a boolean value, received: ${obj.isJourneyMapButton}`)
      return false
    }
  }

  if ("isIncidentMapButton" in obj) {
    if (typeof (obj.isIncidentMapButton) !== "boolean") {
      console.warn(`Column Options validation failed: isIncidentMapButton is not a boolean value, received: ${obj.isIncidentMapButton}`)
      return false
    }
  }

  if ("isBookingRefButton" in obj) {
    if (typeof (obj.isBookingRefButton) !== "boolean") {
      console.warn(`Column Options validation failed: isBookingRefButton is not a boolean value, received: ${obj.isBookingRefButton}`)
      return false
    }
  }

  if ("width" in obj) {
    if (typeof obj.width !== "number") {
      console.warn(`Column Options validation failed: width is not a valid number, received: ${obj.width}`)
      return false
    }
  }

  if ("flex" in obj) {
    if (typeof obj.flex !== "number") {
      console.warn(`Column Options validation failed: flex is not a valid number, received: ${obj.flex}`)
      return false
    }
  }

  if ("isPinned" in obj) {
    if (typeof (obj.isPinned) !== "boolean") {
      console.warn(`Column Options validation failed: isPinned is not a boolean value, received: ${obj.isPinned}`)
      return false
    }
  }

  if ("isSortable" in obj) {
    if (typeof (obj.isSortable) !== "boolean") {
      console.warn(`Column Options validation failed: isSortable is not a boolean value, received: ${obj.isSortable}`)
      return false
    }
  }

  if ("isFilterable" in obj) {
    if (typeof (obj.isFilterable) !== "boolean") {
      console.warn(`Column Options validation failed: isFilterable is not a boolean value, received: ${obj.isFilterable}`)
      return false
    }
  }

  if ("isResizable" in obj) {
    if (typeof (obj.isResizable) !== "boolean") {
      console.warn(`Column Options validation failed: isResizable is not a boolean value, received: ${obj.isResizable}`)
      return false
    }
  }

  if ("hasMenu" in obj) {
    if (typeof (obj.hasMenu) !== "boolean") {
      console.warn(`Column Options validation failed: hasMenu is not a boolean value, received: ${obj.hasMenu}`)
      return false
    }
  }

  return true
}
